import React, { ReactNode } from 'react';
import './App.css';
import { routes } from "./routes";
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import HomePage from './pages/home/HomePage';
import LoginLayout from './components/layout/LoginLayout';
import LoginPage from './pages/auth/loginPage';
import { useSelector } from 'react-redux';
import { RootState } from './redux/store';

const loginpage = "/login";

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const authData = useSelector((state: RootState) => state.auth);
  return authData.isAuthenticated ? <>{children}</> : <Navigate to={loginpage} replace />;
};

function App() {
  const authData = useSelector((state: RootState) => state.auth);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
          <Route index element={<HomePage />} />
          {routes}
        </Route>
        <Route path="/login" element={<LoginLayout />}>
          <Route index element={<LoginPage />} />
        </Route>
        <Route path="*" element={<Navigate to={authData.isAuthenticated ? "/" : loginpage} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
